export enum OrgFrequentNoteKind {
  ManualReviewPass = 'manual_review_pass',
  ManualReviewFail = 'manual_review_fail',
  ManualReview = 'manual_review',
  Annotation = 'annotation',
  Trigger = 'trigger',
}

export type OrgFrequentNote = {
  id: string;
  kind: OrgFrequentNoteKind;
  content: string;
};
